<template>
  <div class="venturi-effect-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>P + 1/2ρv² = Const | 流速大, 压强小$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- The Venturi Tube -->
          <path d="M 0,60 L 150,60 L 200,100 L 250,60 L 400,60" fill="none" stroke="#22a6b3" stroke-width="2" />
          <path d="M 0,180 L 150,180 L 200,140 L 250,180 L 400,180" fill="none" stroke="#22a6b3" stroke-width="2" />
          
          <!-- Liquid coloring -->
          <path d="M 0,60 L 150,60 L 200,100 L 250,60 L 400,60 L 400,180 L 250,180 L 200,140 L 150,180 L 0,180 Z" 
                fill="rgba(34, 166, 179, 0.1)" />

          <!-- Streamlines -->
          <g v-for="i in 5" :key="i">
             <path :d="getStreamline(i)" fill="none" stroke="rgba(255,255,255,0.2)" stroke-width="1" />
          </g>

          <!-- Manometer Tubes -->
          <rect x="50" y="20" width="10" height="40" fill="rgba(255,255,255,0.05)" stroke="#888" />
          <rect x="50" y="60 - h1" width="10" height="h1" fill="#22a6b3" opacity="0.6" />
          <text x="45" y="15" fill="#888" font-size="8">P1</text>

          <rect x="195" y="20" width="10" height="80" fill="rgba(255,255,255,0.05)" stroke="#888" />
          <rect x="195" y="100 - h2" width="10" height="h2" fill="#22a6b3" opacity="0.6" />
          <text x="190" y="15" fill="#888" font-size="8">P2</text>

          <!-- Flow particles -->
          <circle v-for="part in particles" :key="part.id" :cx="part.x" :cy="part.y" r="2" fill="#fff" opacity="0.6" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>喉部流速: {{ (flowVelocity * 2.5).toFixed(1) }} m/s</label>
              <div class="value" style="color: #ff4757">压强差 ΔP: {{ (h1 - h2).toFixed(1) }} units</div>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节总流量</label>
             <el-slider v-model="flowVelocity" :min="1" :max="10" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>文丘里效应是伯努利原理的经典体现。当流体流经一段收缩的管道（喉部）时，根据**连续性方程**，流速必须增大以维持流量不变。根据**伯努利方程**，流速增大会导致在该处的动力压强增加，同时静压强减小。这种压强差被广泛用于化油器喷油、流量计测量以及廉价的喷雾器原理中。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VenturiEffectViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      flowVelocity: 4,
      particles: [],
      timer: null
    }
  },
  computed: {
    h1() { return 30 + this.flowVelocity * 0.5; },
    h2() { return Math.max(5, 30 - this.flowVelocity * 2.2); }
  },
  methods: {
    getStreamline(i) {
       let yOffset = (i - 3) * 20;
       return `M 0,${120 + yOffset} L 150,${120 + yOffset} L 200,${120 + yOffset*0.4} L 250,${120 + yOffset} L 400,${120 + yOffset}`;
    },
    update() {
       if (this.particles.length < 30) {
          this.particles.push({
             id: Math.random(),
             x: 0,
             y: 80 + Math.random() * 80,
             offset: (Math.random() - 0.5) * 40
          });
       }
       
       this.particles.forEach((p, idx) => {
          let speed = this.flowVelocity;
          // Speed up in throat (x between 150 and 250)
          if (p.x > 150 && p.x < 250) {
             speed *= 2.5;
             // Constrict y
             let targetY = 120 + (p.offset * 0.4);
             p.y += (targetY - p.y) * 0.2;
          } else if (p.x >= 250) {
             let targetY = 120 + p.offset;
             p.y += (targetY - p.y) * 0.1;
          } else {
             p.y = 120 + p.offset;
          }
          
          p.x += speed;
          if (p.x > 405) this.particles.splice(idx, 1);
       });
       this.timer = requestAnimationFrame(this.update);
    }
  },
  mounted() { this.update(); },
  beforeDestroy() { cancelAnimationFrame(this.timer); }
}
</script>

<style scoped lang="scss">
.venturi-effect-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(34, 166, 179, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
